import FilterModal from "./FilterModal";
import downloadCSV from "../../utils/downloadCsv";
import type {
  ResultsTableHeaderProps,
  VehicleData
} from "@dealer-center/ddc-pages-inventory-archiver-interface";
import { Button } from "@dealer-center/core-components";

const handleDownloadButtonClick = (data: VehicleData[]): void => {
  if (!data || data.length <= 0) return;
  downloadCSV(data);
};

const ResultsTableHeader = (props: ResultsTableHeaderProps) => {
  return (
    <>
      <FilterModal
        checkedCategories={props.checkedCategories}
        onToggleHeaders={props.onToggleHeaders}
      />
      <Button
        analyticsConfiguration={{ eventName: "Download CSV" }}
        onClick={() => handleDownloadButtonClick(props.data)}
      >
        Download CSV
      </Button>
    </>
  );
};

export default ResultsTableHeader;
